import React from 'react';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { Box, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import state from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocale } from '../../i18n/LocaleContext';

const Settings = () => {
  const { locale, setLocale, t } = useLocale();
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const handleOpenUserMenu = (event: state.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const navigate = useNavigate();

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      <Box sx={{ flexShrink: 0 }}>
        <Tooltip title={t('settings.open')}>
          <IconButton
            color="inherit"
            aria-label={t('settings.open')}
            aria-haspopup="menu"
            aria-expanded={anchorElUser ? 'true' : undefined}
            aria-controls={anchorElUser ? 'menu-appbar' : undefined}
            onClick={handleOpenUserMenu}
          >
            <SettingsOutlinedIcon />
          </IconButton>
        </Tooltip>
        <Menu
          sx={{ mt: '45px' }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >
          <MenuItem disabled>{t('settings.language')}</MenuItem>
          <MenuItem selected={locale === 'de'} onClick={() => setLocale('de')}>
            {t('settings.german')}
          </MenuItem>
          <MenuItem selected={locale === 'en'} onClick={() => setLocale('en')}>
            {t('settings.english')}
          </MenuItem>
          <MenuItem
            key={'logout'}
            onClick={() => {
              handleCloseUserMenu();
              navigate('/logout');
            }}
          >
            <Typography sx={{ textAlign: 'center' }}>{t('navigation.logout')}</Typography>
          </MenuItem>
        </Menu>
      </Box>
    </>
  );
};

export default Settings;
